import RouterView from './RouterView.vue';
import OAuth2Callback from '../auth/type/oauth/v2/Callback.vue';
import Login from '../auth/type/login/Login.vue';

export default [
  {
    path: '/iam/external',
    component: RouterView,
    children: [
      {
        path: 'auth/oauth2/callback/:platform',
        component: OAuth2Callback,
        props: true,
      },
      {
        path: 'auth/login/:platform',
        component: Login,
        props: true,
      },
    ],
  },
];
